import { Avatar, List, ListItem, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { FILE_ERROR_TYPES } from 'Enum/FileErrorTypes';
import { useDictionary } from 'Hooks';
import { RedX } from 'Images';

interface IFileError {
  errorType: number;
}
export const FileError = ({ errorType }: IFileError) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.GENERAL).fileErrors;
  return (
    <Stack
      role='alert'
      sx={{
        p: '2px',
        bgcolor: '#FFEFEF',
        border: '2px solid #FFEFEF',
        borderRadius: '6px',
      }}
    >
      <Stack
        direction='row'
        alignItems='center'
        gap='4px'
        sx={{
          p: '6px 0 6px 8px',
        }}
      >
        <Avatar
          alt=''
          src={RedX}
          sx={{
            width: '25px',
            height: '25px',
          }}
        />
        <Typography
          sx={{
            color: '#D30024',
          }}
        >
          {dictionary.title}
        </Typography>
      </Stack>
      <List
        sx={{
          bgcolor: '#FFFFFF',
          borderRadius: '6px',
          p: 0,
        }}
      >
        <ListItem
          sx={{
            gap: '6px',
            alignItems: 'flex-start',
          }}
        >
          <span
            style={{
              display: 'inline-block',
              minWidth: '5px',
              minHeight: '5px',
              backgroundColor: '#D30024',
              borderRadius: '50%',
              marginTop: '9px',
            }}
          />
          {dictionary.errorNotes[0]}
        </ListItem>
        <ListItem
          sx={{
            gap: '6px',
            alignItems: 'flex-start',
          }}
        >
          <span
            style={{
              display: 'inline-block',
              minWidth: '5px',
              minHeight: '5px',
              backgroundColor: '#D30024',
              borderRadius: '50%',
              marginTop: '9px',
            }}
          />
          {errorType === FILE_ERROR_TYPES.FILE_TYPE_INVALID
            ? dictionary.errorNotes[1]
            : dictionary.errorNotes[2]}
        </ListItem>
      </List>
    </Stack>
  );
};
